import { render, staticRenderFns } from "./LiefengUpload.vue?vue&type=template&id=972083f0&scoped=true&"
import script from "./LiefengUpload.vue?vue&type=script&lang=js&"
export * from "./LiefengUpload.vue?vue&type=script&lang=js&"
import style0 from "./LiefengUpload.vue?vue&type=style&index=0&id=972083f0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972083f0",
  null
  
)

export default component.exports